const GLOWS = {
  teal: 'shadow-[0_40px_90px_-20px_rgba(13,148,136,0.45)]',
  gold: 'shadow-[0_40px_90px_-20px_rgba(245,158,11,0.4)]',
  iskra: 'shadow-[0_40px_100px_-18px_rgba(217,70,239,0.55)]',
  none: 'shadow-[0_40px_80px_-24px_rgba(0,0,0,0.7)]',
};

export const PhoneMockup = ({ src, alt, glow = 'none', className = '', imgClassName = '' }) => (
  <div
    data-testid="phone-mockup"
    className={`relative rounded-[2.6rem] bg-[#0B1424] p-[10px] border border-white/15 ${GLOWS[glow]} ${className}`}
  >
    <div className="absolute top-[10px] left-1/2 -translate-x-1/2 w-[34%] h-[26px] bg-[#0B1424] rounded-b-2xl z-10" aria-hidden="true" />
    <div className="relative overflow-hidden rounded-[2rem] bg-black aspect-[1170/2532]">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`w-full h-full object-cover object-top transition-transform duration-700 ease-out ${imgClassName}`}
      />
    </div>
  </div>
);
